import '@/installCompositionApi'
import '@/installFineMq'

import DotcomBreadcrumb from '@/modules/breadcrumb/Breadcrumb'
import SanitasAccordion from '@/modules/collapsible/SanitasAccordion'
import SanitasCollapsible from '@/modules/collapsible/SanitasCollapsible'
import SanitasHealthForecastQuestionnaire from '@/modules/healthForecast/questionnaire/HealthForecastQuestionnaire'
import SanitasTabItem from '@/modules/tabs/SanitasTabItem'
import SanitasTabs from '@/modules/tabs/SanitasTabs'
import { mount } from '@/mounter'

import SanitasMagazineDossierFooter from '../common/DossierFooter'
import SanitasMagazineTeasers from '../common/MagazineTeasers'
import SanitasMagazineArticle from './MagazineArticle'
import SanitasMagazineCorporateArticle from './MagazineCorporateArticle'
import SanitasMagazineCorporateArticles from './MagazineCorporateArticles'
import SanitasMagazineDownloadLink from './MagazineDownloadLink'
import SanitasMagazineEmbedding from './MagazineEmbedding'
import SanitasMagazineIconBox from './MagazineIconBox'
import SanitasMagazineImageGallery from './MagazineImageGallery'
import SanitasMagazineMedia from './MagazineMedia'
import SanitasMagazinePodcast from './MagazinePodcast'
import SanitasMagazineQuote from './MagazineQuote'
import SanitasMagazineRelatedArticles from './MagazineRelatedArticles'
import SanitasMagazineSocialSharing from './MagazineSocialSharing'

mount('magazine-article', {
  SanitasMagazineArticle,
  SanitasMagazineQuote,
  SanitasMagazineCorporateArticle,
  SanitasMagazineCorporateArticles,
  SanitasMagazineSocialSharing,
  SanitasMagazineDownloadLink,
  SanitasMagazineIconBox,
  SanitasMagazineImageGallery,
  SanitasMagazineMedia,
  SanitasMagazinePodcast,
  SanitasMagazineRelatedArticles,
  SanitasMagazineTeasers,
  SanitasMagazineDossierFooter,
  SanitasHealthForecastQuestionnaire,
  SanitasMagazineEmbedding,
  SanitasCollapsible,
  SanitasAccordion,
  SanitasTabs,
  SanitasTabItem,
  DotcomBreadcrumb,
})
